import type { Action } from 'react-sweet-state';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { CoordinationClient } from '@atlassian/jira-engagement';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import {
	YOUR_WORK_TOUR_MESSAGE_ID,
	PACKAGE_NAME,
	NONE,
	TEAM_NAME,
} from '../../../../common/constants';
import type { YourWorkTourState, ActionProps } from '../../types';

const STARGATE_URL = '/gateway/api';

export type End = (triggerName: string, analyticsEvent: UIAnalyticsEvent) => void;

export const end =
	({ cloudId, setIsYourWorkTourCompleted, orgId }: ActionProps): Action<YourWorkTourState> =>
	({ getState, setState }) =>
	// @ts-expect-error - TS2322 - Type '(triggerName: string, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>' is not assignable to type 'void | Promise<void>'.
	async (triggerName: string, analyticsEvent: UIAnalyticsEvent) => {
		const { currentStep } = getState();
		if (currentStep === NONE) {
			const error = new Error('Tried to end when currentStep is NONE');
			fireErrorAnalytics({
				error,
				meta: {
					id: 'yourWorkTourEnd_currentStepNone',
					packageName: PACKAGE_NAME,
					teamName: TEAM_NAME,
				},
				attributes: {
					message: error.message,
				},
				sendToPrivacyUnsafeSplunk: true,
			});
			throw error;
		}

		fireTrackAnalytics(analyticsEvent, 'YourWorkTour ended', triggerName, {
			currentStep,
		});

		setState({ currentStep: NONE });
		await new CoordinationClient(cloudId, STARGATE_URL, false, orgId).stop(
			YOUR_WORK_TOUR_MESSAGE_ID,
		);
		setIsYourWorkTourCompleted(true);
	};
